import Vue from 'vue'
import router from './router'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueECharts from "vue-echarts";
import "@vue/composition-api";
import "echarts";
import "@/plugins/echarts";
import store from './store';
import firebase from "firebase";
import 'firebase/auth'
import axios from "axios";
import VueCookies from 'vue-cookies';
import * as VueGoogleMaps from 'vue2-google-maps'
import GlobalLoading from './components/global_loading.vue';
import 'echarts/lib/chart/line'; // Import only the necessary chart types
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import globalMixin from './globalMixin'; 
import PaywallPopup from './components/paywall_popup.vue';


// Creating a new Vue instance to serve as an event bus
const EventBus = new Vue();

Vue.prototype.$eventBus = EventBus;

Vue.component('GlobalLoading', GlobalLoading);

Vue.component('PaywallPopup', PaywallPopup);

Vue.use(VueCookies);
Vue.use(VueGoogleMaps,{
  load:{
    key:'AIzaSyABhe3kIzB49v9-QTGyd-ZuoD9pKAp6t5U',
  }
});
const token = window.localStorage.getItem("token");
axios.defaults.withCredentials = false;
axios.defaults.baseURL = "https://api2.byvisit.com/app/v1";
// axios.defaults.baseURL = "https://testapi.byvisit.com/app/v1";
// axios.defaults.allowAbsoluteUrls = true;
// axios.defaults.baseURL = "http://127.0.0.0:8000/app/v1";
axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

// Add interceptor to handle CORS headers
// axios.interceptors.request.use(config => {
//   // Add CORS headers to every request
//   config.headers['Access-Control-Allow-Origin'] = '*';
//   config.headers['Access-Control-Allow-Methods'] = 'DELETE, POST, GET, OPTIONS';
//   config.headers['Access-Control-Allow-Headers'] = 'Content-Type, Authorization, X-Requested-With';
  
//   return config;
// });


// axios.interceptors.response.use(undefined, function(error) {
//   if (error) {
//     console.error(error);
//     const originalRequest = error.config;
//     if (error.response && error.response.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       store.dispatch("logout");
//       return router.push("/login");
//     }
//   }
// });

// import { initializeApp } from 'firebase/app';
Vue.prototype.$http = axios;

Vue.config.productionTip = false

const firebaseConfig = {
 
  apiKey: "AIzaSyC56FXaK9gw3Eb9VUIYKX7NYse8H1Dx5C8",
  authDomain: "byvisit-app.firebaseapp.com",
  projectId: "byvisit-app",
  storageBucket: "byvisit-app.appspot.com",
  messagingSenderId: "444644115779",
  appId: "1:444644115779:web:cd37d09ad351e56bf8dbf6",
  measurementId: "G-486Z54H9WS"
}

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();

Vue.config.productionTip = false;

// Register the global mixin
Vue.mixin(globalMixin);

new Vue({
  vuetify,
  router,
  store,
  VueECharts,
  render: h => h(App),
  mounted() {
    // Set Vue prototype methods to control the loading indicator
    Vue.prototype.$globalLoading = this.$refs.globalLoading;
  },
}).$mount('#app')

// Set up Axios interceptors
axios.interceptors.request.use(
  config => {
    Vue.prototype.$eventBus.$emit('showLoading');
    return config;
  },
  error => {
    Vue.prototype.$eventBus.$emit('hideLoading');
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    Vue.prototype.$eventBus.$emit('hideLoading');
    return response;
  },
  error => {
    Vue.prototype.$eventBus.$emit('hideLoading');
    return Promise.reject(error);
  }
);